"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlanogramFileType = void 0;
var PlanogramFileType;
(function (PlanogramFileType) {
    PlanogramFileType["MEMO"] = "MEMO";
    PlanogramFileType["UPC"] = "UPC";
    PlanogramFileType["CATALOGUE"] = "CATALOGUE";
    PlanogramFileType["RESET_SPECS"] = "RESET SPECS";
})(PlanogramFileType || (PlanogramFileType = {}));
exports.PlanogramFileType = PlanogramFileType;
